<script>
export default {
    name: 'IconRefresh',
}
</script>
<template>
    <svg class="base-icon icon-refresh" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M32.826 1C50.043 1 64 14.88 64 32c0 17.12-13.957 31-31.174 31A31.194 31.194 0 0 1 6.595 48.758l6.604-5.464a22.688 22.688 0 0 0 19.627 11.252c12.522 0 22.672-10.094 22.672-22.546S45.348 9.455 32.826 9.455a22.72 22.72 0 0 0-9.159 1.915 22.607 22.607 0 0 0-7.594 5.44l8.478 4.861-19.365 5.153L0 7.596l8.581 4.92A31.163 31.163 0 0 1 32.826 1Z" clip-rule="evenodd"/></svg>
</template>
